import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import Join from './Join'

import * as UserStateActions from '../../reducers/UserReducer'

function mapStateToProps(state){
  return {
    loggedIn: state.user.loggedIn,
    authLoading:state.user.authLoading,
    auth: state.user.auth,
    uid: state.user.uid,
    user: state.user.user,
  }
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(UserStateActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Join)



// WEBPACK FOOTER //
// ./src/pages/Join/JoinContainer.js